import { DataAmigavel } from "@/shared/utils/datas";
import { Page, Text, View } from "@react-pdf/renderer";
import { PageFooter } from "./ReportPageFooter";
import { chunkArray, ResumoPorDefensoriaETipo, ResumoPorDefensoriaETipoEMovimento } from "../movimentacao.service";
import { parametrosRelatorioMovimentacoes } from "../components/ModalFiltrosMovimentacoes";
import { stylesMovimentacaoReport } from "../components/movimentacao-report-style";

export function ResumoPageDefensoria({ data, parametros }: { data: ResumoPorDefensoriaETipo[], parametros: parametrosRelatorioMovimentacoes }) {
  return (
    <Page size="A4" style={stylesMovimentacaoReport.page} orientation="portrait">
      <Text style={stylesMovimentacaoReport.title}>Relatório de Movimentações por Local</Text>
      <Text style={stylesMovimentacaoReport.subtitle}>Período: {DataAmigavel(parametros.inicio)} - {DataAmigavel(parametros.fim)}</Text>

      {data.map((defensoriaItem, defIndex) => (
        <View key={defIndex} wrap={false} style={{ marginBottom: 10 }}>

          <Text style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 4 }}>
            {defensoriaItem.defensoria}
          </Text>

          {chunkArray(defensoriaItem.tipos, 35).map((chunk: any, chunkIndex: any) => (
            <View key={chunkIndex} style={stylesMovimentacaoReport.table} wrap={false}>
              <View style={stylesMovimentacaoReport.tableRow}>
                <Text style={stylesMovimentacaoReport.tableColRes1}>Tipo</Text>
                <Text style={stylesMovimentacaoReport.tableColRes2}>Quantidade</Text>
              </View>
              {chunk.map((reg: any, i: any) => (
                <View style={stylesMovimentacaoReport.tableRow} key={i}>
                  <Text style={stylesMovimentacaoReport.tableColRes3}>{reg.tipo}</Text>
                  <Text style={stylesMovimentacaoReport.tableColRes4}>{reg.quantidade}</Text>
                </View>
              ))}
            </View>
          ))}
        </View>
      ))}
      <PageFooter />
    </Page>
  );
}

export function ResumoPageDefensoriaMovimentos({ data, parametros }: { data: ResumoPorDefensoriaETipoEMovimento[]; parametros: parametrosRelatorioMovimentacoes }) {

  return (
    <Page size="A4" style={stylesMovimentacaoReport.page} orientation="portrait">
      <Text style={stylesMovimentacaoReport.title}>Relatório de Movimentações por Local</Text>
      <Text style={stylesMovimentacaoReport.subtitle}>
        Período: {DataAmigavel(parametros.inicio)} - {DataAmigavel(parametros.fim)}
      </Text>

      {data.map((defensoriaItem, defIndex) => (
        <View key={defIndex} wrap={false} style={{ marginBottom: 10 }}>

          <Text style={{ fontWeight: "bold", fontSize: 14, marginBottom: 4 }}>
            {defensoriaItem.defensoria}
          </Text>


          {defensoriaItem.categorias.map((categoriaItem, catIndex) => (
            <View key={catIndex} wrap={false} style={{ marginBottom: 8 }}>

              <Text style={{ fontSize: 12, fontWeight: "bold", marginBottom: 4 }}>
                {categoriaItem.categoria}
              </Text>

              {chunkArray(categoriaItem.tipos, 35).map((chunk: any, chunkIndex: any) => (
                <View key={chunkIndex} style={stylesMovimentacaoReport.table} wrap={false}>
                  <View style={stylesMovimentacaoReport.tableRow}>
                    <Text style={stylesMovimentacaoReport.tableColRes1}>Tipo</Text>
                    <Text style={stylesMovimentacaoReport.tableColRes2}>Quantidade</Text>
                  </View>
                  {chunk.map((reg: any, i: any) => (
                    <View style={stylesMovimentacaoReport.tableRow} key={i}>
                      <Text style={stylesMovimentacaoReport.tableColRes3}>{reg.tipo}</Text>
                      <Text style={stylesMovimentacaoReport.tableColRes4}>{reg.quantidade}</Text>
                    </View>
                  ))}
                </View>
              ))}
            </View>
          ))}
        </View>
      ))}

      <PageFooter />
    </Page>
  );
}


export function ResumoPage({ data, label, parametros }: { data: { tipo: string; quantidade: number }[]; label: string; parametros: parametrosRelatorioMovimentacoes }) {
  return (
    <Page size="A4" style={stylesMovimentacaoReport.page} orientation="portrait">
      <Text style={stylesMovimentacaoReport.title}>Relatório de Movimentações por {label}</Text>
      <Text style={stylesMovimentacaoReport.subtitle}>Período: {DataAmigavel(parametros.inicio)} - {DataAmigavel(parametros.fim)}</Text>

      {chunkArray(data, 35).map((chunk: any, chunkIndex: any) => (
        <View key={chunkIndex} style={stylesMovimentacaoReport.table} wrap={false}>
          <View style={stylesMovimentacaoReport.tableRow}>
            <Text style={stylesMovimentacaoReport.tableColRes1}>{label}</Text>
            <Text style={stylesMovimentacaoReport.tableColRes2}>Quantidade</Text>
          </View>
          {chunk.map((reg: any, i: any) => (
            <View style={stylesMovimentacaoReport.tableRow} key={i}>
              <Text style={stylesMovimentacaoReport.tableColRes3}>{reg.tipo}</Text>
              <Text style={stylesMovimentacaoReport.tableColRes4}>{reg.quantidade}</Text>
            </View>
          ))}
        </View>
      ))}
      <PageFooter />
    </Page>
  );
}